<template>
  <v-dialog
    v-model="showModal"
    max-width="500"
  >
    <v-card
      class="mx-auto"
      light
      color="#ECEFF1"
    >
      <v-btn
        fab
        small
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <p class="process-header">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text>
        <p class="message-style">
          {{ message }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          light
          class="next-style"
          text
          @click="confirm()"
        >
          Yes
        </v-btn>
        <v-btn
          class="cancel-style"
          text
          @click="notConfirmed()"
        >
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'AlertDialog',
    props: {
      title: {
        type: String,
        default: 'Confirm Log out',
      },
      message: {
        type: String,
        default: 'Are you sure you want to log out ?',
      },
    },
    data: () => ({
      showModal: true,
    }),
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      confirm () {
        this.$emit('confirmed');
      },
      notConfirmed () {
        this.$emit('closed');
      },
    },
  };
</script>
<style scoped>
.message-style {
    font-weight: 500;
    color: #455A64;
    font-size: 16px;
}
</style>
